import React, { useState } from "react";
import { useAppSelector } from "../../store/store";
import styles from "./index.module.css";
import { tracker } from "../../services/mixpanel";
import { useContactUsMutation } from "../../services/api";
import { showNotification } from "../../services/showNotification";

const ContactUsTile = () => {
  const [question, setQuestion] = useState("");
  const purlUser = useAppSelector((state) => state.purlUser);
  const loginData = useAppSelector((state) => state.login);
  const [contactUs, { isLoading, isSuccess, isError }] = useContactUsMutation();


  const getName = () => {
    if (loginData.role === "ADVISOR") return purlUser.advisorName;
    else if (loginData.role === "BOOKKEEPER") return purlUser.bookkeeperName;
    else if (loginData.role === "CPA") return purlUser.cpaName;
    else return `${loginData.firstName} ${loginData.lastName}`;
  };

  const clientName = getName();

  
  const handleSubmit = async () => {
    if (!question.trim()) {
      showNotification("error","Please type your question");
      return;
    }
    if (clientName && purlUser.email) {
      await contactUs({ clientName, question, email: purlUser.email });
    }
    setQuestion("");
  };

  return (
    <div className={`bg-[#FEFCFB] rounded-xl w-full pt-1 shadow-lg h-[390px]`}>
      <div>
        <h2
          className="text-[25px] mb-[8px] p-1 text-black font-normal"
          style={{ fontFamily: "Signika" }}
        >
          Contact Us
        </h2>
        <div className="text-[14px] border-t-4 pt-4 px-4 border-[#EFEFF4]">
          Have a question or need assistance? Submit your inquiry below and our
          team will get back to you promptly.
        </div>
      </div>
      <div className="flex items-center justify-center h-[60%] px-4">
        <div className="flex w-full items-center gap-4">
          <textarea
            className="w-full h-[100px] p-2 border rounded-sm resize-none text-[16px] focus:outline-none focus:border-[#356C58]"
            placeholder="Type your question here"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
          <button
            onClick={handleSubmit}
            className="bg-[#356C58] text-white rounded-sm text-[17px] py-2 px-4 h-[40px] whitespace-nowrap"
            disabled={isLoading ||!question.trim()}
          >
           {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsTile;
